import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font
} from '@react-pdf/renderer'
import PoppinsExtraLight from '../Fonts/Poppins/Poppins-ExtraLight.ttf'
import PoppinsLight from '../Fonts/Poppins/Poppins-Light.ttf'
import PoppinsRegular from '../Fonts/Poppins/Poppins-Regular.ttf'
import PoppinsSemiBold from '../Fonts/Poppins/Poppins-SemiBold.ttf'
import PoppinsExtraBold from '../Fonts/Poppins/Poppins-ExtraBold.ttf'
import Variables from '../global'

function PdfTable ({ tableSettings, tableData = [] }) {
  const tableStyle = {
    tableContainer: { padding: '10px 0', zIndex: 1 },
    tableName: { fontSize: '13px', textAlign: 'left', fontWeight: 'bold' },
    noData: { fontSize: '11px', textAlign: 'center', padding: '20px 0' },
    table: {
      width: '100%',
      fontSize: '10px',
      margin: '20px 0',
      borderLeft: '1px solid lightgrey'
    },
    cell: {
      minHeight: '20px',
      padding: '2px 5px',
      display: 'flex',
      justifyContent: 'center'
    },
    head: {},
    headRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    headCell: {
      flex: 1,
      borderTopWidth: 1,
      borderRightWidth: 1,
      borderBottomWidth: 1,
      fontWeight: 'bold',
      textAlign: 'center',
      borderColor: 'lightgrey'
    },
    body: {},
    bodyRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    bodyCell: {
      flex: 1,
      borderRightWidth: 1,
      borderBottomWidth: 1,
      textAlign: 'center',
      borderColor: 'lightgrey'
    },
    footer: {},
    footerRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      fontWeight: 'bold',
      alignItems: 'center'
    },
    footerCell: {
      flex: 1,
      borderRightWidth: 1,
      borderBottomWidth: 1,
      padding: '3px 0',
      textAlign: 'center',
      borderColor: 'lightgrey'
    }
  }
  return (
    <View style={[tableStyle.tableContainer, { width: tableSettings.width }]}>
      <Text style={tableStyle.tableName}>{tableSettings.name}</Text>
      {tableData && tableData.length > 0 && (
        <View style={tableStyle.table}>
          <View style={tableStyle.head}>
            <View style={tableStyle.headRow}>
              {tableSettings.columns.map((column, index) => {
                console.log(column.width)
                return (
                  <View
                    style={[
                      tableStyle.cell,
                      tableStyle.headCell,
                      { width: column.width }
                    ]}
                    key={index + 1}
                  >
                    <Text>{column.title}</Text>
                  </View>
                )
              })}
            </View>
          </View>
          <View style={tableStyle.body}>
            {tableData.map((row, index) => {
              return (
                <View
                  style={
                    index + 1 > tableData.length - tableSettings.footerRows
                      ? tableStyle.footerRow
                      : tableStyle.bodyRow
                  }
                  key={index + 1}
                >
                  {tableSettings.columns.map((column, index) => {
                    let key = index + 1
                    let propertyIsArray = Array.isArray(column.property)
                    let value
                    if (propertyIsArray) {
                      value = []
                      column.property.forEach(p => {
                        if (p.includes('.')) {
                          let v
                          let _properties = p.split('.')
                          v = row
                          _properties.forEach(_property => (v = v[_property]))
                          value.push(v)
                        } else {
                          value.push(row[p])
                        }
                        if (!column.mutate) {
                          value = value.join(',')
                        }
                      })
                    } else {
                      if (column.property.includes('.')) {
                        let _properties = column.property.split('.')
                        value = row
                        _properties.forEach(
                          _property => (value = value[_property])
                        )
                      } else {
                        value = row[column.property]
                      }
                    }

                    if (column.mutate) {
                      value = column.mutate(value)
                    }

                    return (
                      <View
                        style={[
                          tableStyle.cell,
                          tableStyle.bodyCell,
                          {
                            width: column.width,
                            textAlign:
                              column?.type == 'number' ? 'right' : 'center'
                          }
                        ]}
                        key={key}
                      >
                        <Text>{value}</Text>
                      </View>
                    )
                  })}
                </View>
              )
            })}
          </View>

          <>
            {/* <tbody>
            {tableData &&
              tableData.length > 0 &&
              tableData.map((d, index) => {
                return (
                  <tr key={index + 1}>
                    {columns.map((column, index) => {
                      let key = index + 1
                      let propertyIsArray = Array.isArray(column.property)
                      let value
                      if (propertyIsArray) {
                        value = []
                        column.property.forEach(p => {
                          if (p.includes('.')) {
                            let v
                            let _properties = p.split('.')
                            v = d
                            _properties.forEach(_property => (v = v[_property]))
                            value.push(v)
                          } else {
                            value.push(d[p])
                          }
                          if (!column.mutate) {
                            value = value.join(',')
                          }
                        })
                      } else {
                        if (column.property.includes('.')) {
                          let _properties = column.property.split('.')
                          value = d
                          _properties.forEach(
                            _property => (value = value[_property])
                          )
                        } else {
                          value = d[column.property]
                        }
                      }

                      if (column.mutate) {
                        value = column.mutate(value)
                      }

                      switch (column.type) {
                        case 'actions-list':
                          return (
                            <td className={column.type} key={key}>
                              <div className="actions-container">
                              {value}
                              </div>
                            </td>
                          )
                        case 'image':
                          return (
                            <td key={key}>
                              <img src={value} />
                            </td>
                          )
                        case 'label':
                          return (
                            <td className='label' key={key}>
                              {value}
                            </td>
                          )
                        case 'file':
                          return value ? (
                            <td className='file' key={key}>
                              {value}
                            </td>
                          ) : (
                            <td></td>
                          )
                        case 'checkbox':
                          return (
                            <td key={key}>
                              <input
                                type='checkbox'
                                name={column.property + '[]'}
                                readOnly
                                checked={value}
                                value={value}
                              />
                            </td>
                          )
                        default:
                          return (
                            <td style={column.style?.rows} key={key}>
                              {value}
                            </td>
                          )
                      }
                    })}
                  </tr>
                )
              })}
          </tbody> */}
          </>
        </View>
      )}
      {(!tableData || tableData.length === 0) && (
        <View style={tableStyle.noData}>
          <Text>Verilmiş parametrlərə uyğun məlumat mövcud deyil.</Text>
        </View>
      )}
    </View>
  )
}

const PdfWaterMark = () => {
  let courseLogoSrc =  `${Variables.api_url}/images/settings/course_logo.png`
  const waterMark = StyleSheet.create({
    container: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      opacity: '0.1',
      zIndex: 0
    },
    image: { width: '30%' }
  })
  return (
    <View fixed style={waterMark.container}>
      <Image style={waterMark.image} src={courseLogoSrc}></Image>
    </View>
  )
}

function PdfFooter () {
  let appLogoSrc = '/Images/Logos/app_logo_dark.png'
  const footer = StyleSheet.create({
    container: {
      position: 'absolute',
      left: '0px',
      bottom: '0px',
      width: '100%',
      height: '40px',
      padding: '0 30px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      opacity: '0.8',
      zIndex: 1
    },
    logo: { height: '10px', padding: '0 10px', opacity: '0.5' },
    text: { fontSize: '8px' }
  })
  return (
    <View style={footer.container}>
      <Text style={footer.text}>
        Bu hesabat {new Date().toLocaleDateString('ru-RU')} tarixində
      </Text>
      <Image style={footer.logo} src={appLogoSrc}></Image>
      <Text style={footer.text}> tətbiqindən əldə edilmişdir.</Text>
    </View>
  )
}

function CashFlowReport ({ reportData }) {
  Font.register({
    family: 'Poppins',
    fonts: [
      { src: PoppinsExtraLight, fontWeight: 'lighter' },
      { src: PoppinsLight, fontWeight: 'light' },
      { src: PoppinsRegular, fontWeight: 'normal' },
      { src: PoppinsSemiBold, fontWeight: 'bold' },
      { src: PoppinsExtraBold, fontWeight: 'bolder' }
    ]
  });

  reportData.reportParameters = reportData?.reportParameters[0];
  const report = StyleSheet.create({
    page: {
      position: 'relative',
      padding: '30px 30px 50px',
      fontFamily: 'Poppins'
    },
    header: {
      fontSize: '16px',
      textAlign: 'center',
      fontWeight: 'bold',
      padding: '10px 0'
    },
    subHeader: { fontSize: '12px', textAlign: 'center', fontWeight: 'normal' },
    section: { margin: 10, padding: 10, flexGrow: 1, width: '50%' },
    row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'start'
    },
    column: { border: '1px solid black', width: '50%' }
  })

  const operationsTableSettings = {
    name: 'Əməliyyatlar',
    width: '100%',
    display: 'block',
    border: 'none',
    footerRows: 0,
    columns: [
      {
        title: 'Əməliyyat növü',
        property: 'typeName',
        width: '15%'
      },
      {
        title: 'Tarix',
        property: 'date',
        width: '15%',
        mutate: value => {
          return new Date(value).toLocaleDateString('ru-RU')
        }
      },
      [undefined,null,''].includes(reportData.reportParameters?.branchId) ? {
        title: 'Filial',
        property: 'branchName',
        type: 'text',
        width: '15%'
      }:null,
      {
        title: 'Məbləğ',
        property: 'amount',
        type: 'number',
        width: '150px',
        mutate: value => {
          return `${value} AZN`
        }
      },
      {
        title: 'Açıqlama',
        property: 'description',
        width: '45%'
      }
    ].filter(f=>f)
  }

  const totalsTableSettings = {
    name: 'Yekun',
    width: '40%',
    display: 'block',
    border: 'none',
    footerRows: 2,
    columns: [
      {
        title: 'Başlıq',
        property: 'typeName',
        width: '60%'
      },
      {
        title: 'Cəmi məbləğ',
        property: 'amount',
        type: 'number',
        width: '40%',
        mutate: value => {
          return `${value} AZN`
        }
      }
    ]
  }

  const expensesByCategoriesTableSettings = {
    name: 'Xərclər (kateqoriyalar üzrə)',
    width: '45%',
    display: 'block',
    border: 'none',
    footerRows: 1,
    columns: [
      {
        title: 'Kateqoriya',
        property: 'typeName',
        width: '60%'
      },
      {
        title: 'Cəmi məbləğ',
        property: 'amount',
        type: 'number',
        width: '40%',
        mutate: value => {
          return `${value} AZN`
        }
      }
    ]
  }

  return (
    <Document>
      <Page size='A4' orientation='landscape' style={report.page}>
        <PdfWaterMark />
        <PdfFooter />
        <View>
          <Text style={report.header}>Dövriyyə Hesabatı</Text>

          {reportData?.reportParameters?.branchName && (
            <Text style={[report.subHeader,{fontWeight:'bold',marginBottom:'5px'}]}>
              Filial ({reportData?.reportParameters?.branchName}) üzrə
            </Text>
          )}

          <Text style={report.subHeader}>
            Dövr:{' '}
            {new Date(reportData?.reportParameters?.from).toLocaleDateString(
              'ru-RU'
            )}{' '}
            -{' '}
            {new Date(reportData?.reportParameters?.to).toLocaleDateString(
              'ru-RU'
            )}
          </Text>
        </View>
        <View>
          <PdfTable
            tableSettings={operationsTableSettings}
            tableData={reportData.operations}
          />
        </View>
      </Page>
      <Page size='A4' orientation='landscape' style={report.page}>
        <PdfWaterMark />
        <PdfFooter />
        <View style={report.row}>
          <PdfTable
            tableSettings={expensesByCategoriesTableSettings}
            tableData={reportData.expensesByCategories}
          />
          <PdfTable
            tableSettings={totalsTableSettings}
            tableData={reportData.totals}
          />
        </View>
      </Page>
    </Document>
  )
}

export default CashFlowReport
